import { render } from "./CustomerLotEoiDetails.vue?vue&type=template&id=3b5773d4&scoped=true&ts=true&lang=pug"
import script from "./CustomerLotEoiDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerLotEoiDetails.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerLotEoiDetails.vue?vue&type=style&index=0&id=3b5773d4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5773d4"]])

export default __exports__